import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/main',
    component: () => import('../views/MainPanel'),
    children: [
      {
        path: 'daily',
        name: 'dailyInfo',
        component: () => import('../views/DailyReportView')
      },
      {
        path: 'search',
        name: 'search-page',
        component: () => import('../views/SearchPage')
      },
      {
        path: 'concerned',
        name: 'ConcernedPanel',
        component: () => import('../views/ConcernedInfoPage')
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('../views/UserManagement')
      }
    ]
  },
  {
    path: '/concerned',
    component: () => import('../views/ConcernedInfoPage.vue')
  },
  {
    path: '/wechat/login',
    component: () => import('../views/WeChatLoginPage.vue')
  },
  {
    path: '/public',
    component: () => import('../views/PublicPanel'),
    children: [
      {
        path: 'daily',
        name: 'public-daily',
        component: () => import('../views/DailyReportView')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
